import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from "../../services/ApiService";
import Loader from "../../components/Loader";
import { formatCurrency } from '../../utils/helper';
import { toast } from 'react-toastify';

const InventoryReport = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalValue, setTotalValue] = useState(0);
    const [filters, setFilters] = useState({
        low_stock: false
    });

    const fetchReport = async () => {
        setLoading(true);
        try {
            const response = await ApiService.request({
                method: 'GET',
                url: 'admin/reports/inventory',
                data: filters
            });
            if (response.data.status) {
                setData(response.data.data.products);
                setTotalValue(response.data.data.total_inventory_value);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch inventory report");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReport();
    }, [filters.low_stock]);

    const handleFilterChange = (e) => {
        const { name, checked } = e.target;
        setFilters(prev => ({ ...prev, [name]: checked }));
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            Inventory Report
                        </h1>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card mb-5 mb-xl-10">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="d-flex align-items-center position-relative my-1 gap-3">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="low_stock"
                                            checked={filters.low_stock}
                                            onChange={handleFilterChange}
                                            id="low_stock_check"
                                        />
                                        <label className="form-check-label" htmlFor="low_stock_check">
                                            Low Stock Only
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-toolbar">
                                <div className="d-flex justify-content-end gap-2">
                                    <div className="fw-bold fs-5 text-gray-800 border border-gray-200 p-2 rounded d-flex align-items-center">
                                        Total Value: {formatCurrency(totalValue)}
                                    </div>
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Export to Excel</Tooltip>}>
                                        <button onClick={() => {
                                            const csvContent = "data:text/csv;charset=utf-8," 
                                                + "Product Name,Category,Stock,Price,Total Value\n"
                                                + data.map(e => `${e.name},${e.category?.name || 'N/A'},${e.stock},${e.price},${e.stock * e.price}`).join("\n");
                                            const encodedUri = encodeURI(csvContent);
                                            const link = document.createElement("a");
                                            link.setAttribute("href", encodedUri);
                                            link.setAttribute("download", `inventory_report.csv`);
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }} className="btn btn-light-primary">
                                            <i className="fas fa-file-export me-2"></i> Export to Excel
                                        </button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>

                        <div className="card-body py-4">
                            {loading ? <Loader /> : (
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th>Product Name</th>
                                                <th>Category</th>
                                                <th>Stock</th>
                                                <th>Price</th>
                                                <th className="text-end">Total Value</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold">
                                            {data.length > 0 ? (
                                                data.map((product) => (
                                                    <tr key={product.id}>
                                                        <td>{product.name}</td>
                                                        <td>{product.category || '-'}</td>
                                                        <td>
                                                            <span className={`badge badge-light-${product.stock <= (product.min_stock_level || 5) ? 'danger' : 'success'}`}>
                                                                {product.stock}
                                                            </span>
                                                        </td>
                                                        <td>{formatCurrency(product.price)}</td>
                                                        <td className="text-end">{formatCurrency(product.stock * product.price)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No records found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryReport;
